/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

/**
 * Banner action kind enumeration.
 */
export type BannerActionKind = typeof BannerActionKind[keyof typeof BannerActionKind];


export const BannerActionKind = {
  user_profile: 'user_profile',
  shelf: 'shelf',
  categories: 'categories',
  paywall: 'paywall',
  book: 'book',
  collection: 'collection',
  category: 'category',
} as const;
